import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../common/state/store";

interface IGraphuState {
  isValid: boolean;
  isLoading: boolean;
  shouldRerender: boolean;
  showAllAssets: boolean;
}
const initialState: IGraphuState = {
  isValid: false,
  isLoading: false,
  shouldRerender: false,
  showAllAssets: true,
};

export const graphuSlice = createSlice({
  name: "graphu",
  initialState,
  reducers: {
    setIsValid: (state, action: PayloadAction<boolean>) => {
      state.isValid = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setShouldRerender: (state) => {
      state.shouldRerender = !state.shouldRerender;
    },
    setShowAllAssets: (state, action: PayloadAction<boolean>) => {
      state.showAllAssets = action.payload;
    },
    toggleShowAllAssets: (state) => {
      state.showAllAssets = !state.showAllAssets;
    },
  },
});

export const {
  setIsValid,
  setIsLoading,
  setShouldRerender,
  setShowAllAssets,
  toggleShowAllAssets,
} = graphuSlice.actions;

export const getIsValid = (state: RootState) => state.graphu.isValid;
export const getIsLoading = (state: RootState) => state.graphu.isLoading;
export const getShouldRerenderGraph = (state: RootState) => state.graphu.shouldRerender;
export const getShowAllAssets = (state: RootState) => state.graphu.showAllAssets;

export default graphuSlice.reducer;
